import { toast } from 'react-toastify';

import { AppDispatch } from '..';
import { getBootstrapData } from '../../api';
import { Logger } from '../../utils/Logger';
import { success as frontRunnerSuccess } from '../front-runner/reducer';
import { success as securitySuccess } from '../security/reducer';
import { success as strategiesSuccess } from '../strategy/reducer';
import { success as strategyLegsSuccess } from '../strategy-leg/reducer';
import { success as systemProfileSuccess } from '../system-profile/reducer';
import { success as trendLineSuccess } from '../trend-line/reducer';
import { success as volatilityProfileSuccess } from '../volatility-profile/reducer';

import { loading, success, fail } from './reducer';

export const loadBootstrapDataAsync = () => {
  return (dispatch: AppDispatch) => {
    dispatch(loading(true));
    getBootstrapData()
      .then((response) => {
        const foundationData = response.data;
        Logger.log(foundationData);
        dispatch(success(foundationData));
        dispatch(systemProfileSuccess(foundationData.systemProfile));
        dispatch(securitySuccess(foundationData.securities));
        dispatch(trendLineSuccess(foundationData.trendLines));
        dispatch(frontRunnerSuccess(foundationData.frontRunners));
        dispatch(volatilityProfileSuccess(foundationData.volatilityProfiles));
        dispatch(strategiesSuccess(foundationData.strategies));
        dispatch(strategyLegsSuccess(foundationData.legs));
      })
      .catch((error) => {
        const msg = error.response?.data.message || error.message;
        dispatch(fail(msg));
        toast.error(msg);
      })
      .finally(() => {
        dispatch(loading(false));
      });
  };
};
